import { useReducer, useEffect } from "react";
import chargerConfigReducer from "./reducer";
import { fetchChargerConfig } from "./api";
import ACTIONS from "./actions";

const initialState = {
  isLoading: true,
  isError: false,
  data: null,
};

async function getChargerConfig(dispatch, siteId, chargerId) {
  dispatch({ type: ACTIONS.FETCH_CHARGER_CONFIG_INIT });
  try {
    const res = await fetchChargerConfig(siteId, chargerId);
    dispatch({ type: ACTIONS.FETCH_CHARGER_CONFIG_SUCCESS, payload: res });
  } catch (e) {
    dispatch({ type: ACTIONS.FETCH_CHARGER_CONFIG_FAILURE });
  }
}

function useChargerConfig(siteId, chargerId) {
  const [state, dispatch] = useReducer(chargerConfigReducer, initialState);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (siteId && chargerId) {
        getChargerConfig(dispatch, siteId, chargerId);
      }
    }, 1000);
    return () => clearTimeout(handler);
  }, [siteId, chargerId]);

  return {
    config: state.data,
    loading: state.isLoading,
    error: state.isError,
    dispatch,
  };
}

export default useChargerConfig;
